/*
 * ATTENTION! Put only public interfaces in this file and export them all!
 */
export var NotificationTypeV1;
(function (NotificationTypeV1) {
    /** Generic popup notification without any additional content except for the close button */
    NotificationTypeV1["POPUP_GENERIC"] = "popup-generic";
    /** Popup notification that contains a green success icon next to the provided content */
    NotificationTypeV1["POPUP_SUCCESS"] = "popup-success";
    /** Popup notification that contains a red error icon next to the provided content */
    NotificationTypeV1["POPUP_ERROR"] = "popup-error";
    // /** Sticky notification that is displayed above the header */
    // STICKY = 'sticky' // not yet implemented
})(NotificationTypeV1 || (NotificationTypeV1 = {}));
/**
 * Reason the notifcation was closed
 */
export var NotificationCloseTriggerV1;
(function (NotificationCloseTriggerV1) {
    /** The notfication was closed automatically after the provided timeout */
    NotificationCloseTriggerV1["AUTO"] = "auto";
    /** User clicked x (close button) */
    NotificationCloseTriggerV1["CLICK"] = "click";
    /** Close on navigation, if detectable */
    NotificationCloseTriggerV1["NAVIGATION"] = "navigation";
    /** The notification itself triggered closing (e.g. NBA was clicked) */
    NotificationCloseTriggerV1["SELF"] = "self";
    /** Owner/Consumer that created the notification closed the notification */
    NotificationCloseTriggerV1["OUTSIDE"] = "outside";
})(NotificationCloseTriggerV1 || (NotificationCloseTriggerV1 = {}));
export var NotificationCloseTypeV1;
(function (NotificationCloseTypeV1) {
    /** Close notification when the integrator page is changed */
    NotificationCloseTypeV1["NAVIGATION"] = "navigation";
    /** Close notification only when user dismisses it */
    NotificationCloseTypeV1["CLICK"] = "click";
})(NotificationCloseTypeV1 || (NotificationCloseTypeV1 = {}));
//# sourceMappingURL=types.js.map